import _regeneratorRuntime from "D:\\workFile\\qingbeiCode\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import List from "@/components/List.vue";
import PackageItem from "@/modules/stu/components/package/PackageItem.vue";
import Classify from "@/modules/stu/components/Classify.vue";
import ListSort from "@/modules/stu/components/ListSort.vue";
import SearchKeyWords from "@/modules/stu/components/SearchKeyWords.vue";
import EmptyNew from "@/components/EmptyNew.vue";
export default {
  name: "Package",
  components: {
    List: List,
    PackageItem: PackageItem,
    Classify: Classify,
    ListSort: ListSort,
    SearchKeyWords: SearchKeyWords,
    EmptyNew: EmptyNew
  },
  data: function data() {
    return {
      classifyList: [],
      subClassify: 0,
      course_id: this.$route.query.course_id,
      sort: 0,
      classify_id: 0
    };
  },
  computed: {
    search: function search() {
      return {
        classify_id: this.subClassify || this.classify_id,
        order_by: this.sort,
        recommend: this.$route.query.recommend,
        course_id: this.course_id,
        keywords: this.$route.query.keywords
      };
    },
    classifyItems: function classifyItems() {
      var items = [];
      items.push({
        id: "classify_id",
        name: "课程分类",
        value: {
          item: this.classify_id,
          child: this.subClassify
        },
        children: this.classifyList
      });
      return items;
    }
  },
  watch: {
    $route: function $route() {
      this.$refs.list.searchRefresh();
    },
    sort: function sort() {
      this.$refs.list.searchRefresh();
    }
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getClassify();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    getClassify: function () {
      var _getClassify = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var params, data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = {};

                if (this.$route.query.recommend) {
                  params.recommend = this.$route.query.recommend;
                }

                _context2.next = 4;
                return this.$http.get("/api/app/packageCourseClassify/index", params);

              case 4:
                data = _context2.sent;
                data.classify.unshift({
                  id: 0,
                  name: "全部"
                });
                data.classify.forEach(function (c) {
                  if (!c.children) {
                    return;
                  }

                  c.children.unshift({
                    id: 0,
                    name: "全部"
                  });
                });
                this.classifyList = data.classify;

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getClassify() {
        return _getClassify.apply(this, arguments);
      }

      return getClassify;
    }(),
    onClassifyChange: function onClassifyChange(_ref) {
      var id = _ref.id,
          value = _ref.value;
      this[id] = value.item;
      this.subClassify = value.child;
      this.$refs.list.searchRefresh();
    },
    onClearCourse: function onClearCourse() {
      this.course_id = "";
      this.$refs.list.searchRefresh();
    }
  }
};